// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yupQGnCLd88yS6yQl2DV{flex-direction:column;flex-grow:1;justify-content:center;align-items:center;display:flex}.yupQGnCLd88yS6yQl2DV .vjow1WwSorcF4dQpwIHJ{border-radius:12px;min-height:276px;margin-bottom:40px;overflow:hidden}.yupQGnCLd88yS6yQl2DV .vjow1WwSorcF4dQpwIHJ img{max-width:628px;display:block}.gkfmoGcANdUzerZlDh3D{gap:8px;margin-top:24px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `yupQGnCLd88yS6yQl2DV`,
	"preview": `vjow1WwSorcF4dQpwIHJ`,
	"actions": `gkfmoGcANdUzerZlDh3D`
};
export default ___CSS_LOADER_EXPORT___;
